import featureActionName from 'store/utils';

import { FEATURE_NAME } from './consts';

export const actionName = featureActionName(FEATURE_NAME);
